import {Component} from '@angular/core';
import {AuthenticationService} from '../authentication.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent {

  constructor(public authenticationService: AuthenticationService) {
  }

  submitted = false;
  email: string;

  signUp() {
    this.authenticationService.ForgotPasswod(this.email);
    this.submitted = true;
  }

}
